import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import * as api from 'api/methods';

import { useFetch } from 'hooks/useFetch';

import { convertDataToApi } from './CreateArcade.helpers';

import CreateArcade from './CreateArcade';

const CreateArcadeContainer = ({
  open,
  ...restProps
}: { open: any } & Record<string, any>) => {
  const navigate = useNavigate();

  const [createLoading, setCreateLoading] = useState(false);

  const { data: schools } = useFetch(
    {
      defaultData: [],
      fetcher: api.getSchools,
      immediately: false,
      stopRequest: !open,
    },
    null,
    [open],
  );

  const handleCreateClick = async (
    values: any,
    { resetForm }: { resetForm: any },
  ) => {
    setCreateLoading(true);

    try {
      const arcade = await api.createArcade(convertDataToApi(values));

      resetForm();

      navigate(`/arcades/${arcade.id}`);
    } catch (error) {
      console.warn(error); // TODO: catch error
    }

    setCreateLoading(false);
  };

  const schoolOptions = schools.map((school: any) => ({
    label: school.name,
    value: school.id,
  }));

  return (
    <CreateArcade
      {...restProps}
      open={open}
      createLoading={createLoading}
      schoolOptions={schoolOptions}
      onCreateClick={handleCreateClick}
    />
  );
};

export default React.memo(CreateArcadeContainer) as any;
